import React from "react";
import PropTypes from "prop-types";
import { Text } from "@shopify/polaris";

import {
  formatPerformanceAvgOrderValue,
  formatPerformanceCurrency,
  formatPerformanceCurrencyK,
  formatPerformanceOrders,
} from "app/dashboard/modules/operator/dashboardConfig";

const TABLE_HEADINGS = ["Date", "GMV", "Your Revenue", "Operating Costs", "Total Orders", "Avg Order Value"];

const PerformanceTable = ({ rows }) => (
  <div className="operator-dashboard-performance-table">
    <table>
      <thead>
        <tr>
          {TABLE_HEADINGS.map((heading, index) => (
            <th
              key={heading}
              className={index === 0 ? "operator-dashboard-performance-table__head--date" : ""}
            >
              <Text as="span" variant="bodySm" tone="subdued" fontWeight="semibold">
                {heading}
              </Text>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.date}>
            <td className="operator-dashboard-performance-table__date">
              <Text as="span" variant="bodyMd" fontWeight="semibold">
                {row.date}
              </Text>
            </td>
            <td className="operator-dashboard-performance-table__numeric">
              <Text as="span" variant="bodyMd">
                {formatPerformanceCurrencyK(row.gmv)}
              </Text>
            </td>
            <td className="operator-dashboard-performance-table__numeric">
              <Text as="span" variant="bodyMd">
                {formatPerformanceCurrency(row.revenue)}
              </Text>
            </td>
            <td className="operator-dashboard-performance-table__numeric">
              <Text as="span" variant="bodyMd">
                {formatPerformanceCurrencyK(row.operatingCosts)}
              </Text>
            </td>
            <td className="operator-dashboard-performance-table__numeric">
              <Text as="span" variant="bodyMd">
                {formatPerformanceOrders(row.orders)}
              </Text>
            </td>
            <td className="operator-dashboard-performance-table__numeric">
              <Text as="span" variant="bodyMd">
                {formatPerformanceAvgOrderValue(row.avgOrderValue)}
              </Text>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

PerformanceTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      gmv: PropTypes.number.isRequired,
      revenue: PropTypes.number.isRequired,
      operatingCosts: PropTypes.number.isRequired,
      orders: PropTypes.number.isRequired,
      avgOrderValue: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default PerformanceTable;
